import React, { useEffect, useRef, useState } from 'react';
import Loader from 'Common/Loader';
import { Card, Modal } from 'react-bootstrap';
import DataGrid, { Column, Pager, Paging, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { Result } from 'antd';
import { getAllCompanyData } from '../services/company.service';

const CompanyMasterMain: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [permissionDetails, setPermissionDetails] = useState<string[]>([]);
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        const authUserString = localStorage.getItem("authPOSUser");
        if (authUserString) {
            const authUser = JSON.parse(authUserString);
            const permissionData = authUser?.permissions || [];
            setPermissionDetails(permissionData);
        }
    }, []);

    const HasPermission = (permission: string): boolean => {
        return permissionDetails.includes(permission);
    };

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    let parameterList = new URLSearchParams();
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }
                    const response = await getAllCompanyData(parameterList);
                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }

    const reloadDataSource = () => {
        setRefreshKey(prev => prev + 1);
    };

    return (
        <React.Fragment>
            {loading && <Loader />}
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Company Master</h5>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {HasPermission("Category.Read") ?
                                <DataGrid
                                    dataSource={dataSource()}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    key={refreshKey}
                                    showBorders={true}
                                >
                                    <Pager
                                        visible={true}
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <Summary>
                                        <TotalItem
                                            // column="Sr.No."
                                            // summaryType="count"
                                            // displayFormat="Total Companies: {0}"
                                        />
                                    </Summary>
                                    <Paging defaultPageSize={10} />
                                    <SearchPanel visible width={240} placeholder="Search..." />

                                    <Column
                                        caption="Sr.No."
                                        dataType="number"
                                        alignment="center"
                                        cellRender={(e) => {
                                            const rowIndex = e.rowIndex + 1 + e.component.pageIndex() * e.component.pageSize();
                                            return <span>{rowIndex}</span>;
                                        }}
                                    />
                                    <Column dataField="companyName" caption="Company Name" dataType="string" />
                                    <Column dataField="companyCode" caption="Company Code" dataType="string" />
                                </DataGrid>
                                :
                                <div className="text-center fs-5 fw-bold">
                                    <Result
                                        status="403"
                                        title="401"
                                        subTitle="Sorry, you are not authorized to access this data."
                                        className="custom-result"
                                    />
                                </div>
                            }
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CompanyMasterMain;
